"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const formatEventDate = (dateString?: string) => {
  if (!dateString) return "TBA";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    }).toUpperCase();
  } catch (e) {
    return "TBA";
  }
};
function ThePulseGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="129478" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="animate-pulse rounded-xl border border-border/50 bg-card/30 p-4">
            <div className="mb-4 aspect-[4/3] w-full rounded-lg bg-muted/50" />
            <div className="h-6 w-3/4 rounded bg-muted/50" />
            <div className="mt-2 h-4 w-1/2 rounded bg-muted/50" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-xl border border-destructive/20 bg-destructive/5 p-6 text-center text-destructive">
        <p>Unable to load the latest events at this time.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-xl border border-border/50 bg-card/30 p-6 text-center text-muted-foreground">
        <p>No upcoming events found. Check back soon!</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="h-full">
          <Link to={post.link || "#"} className="group block h-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-xl">
            <Card className="h-full overflow-hidden border-none bg-card/40 backdrop-blur-xl transition-all duration-700 hover:bg-card/60 shadow-inner shadow-black/20 hover:shadow-primary/20">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={4 / 3}>
                  <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/generic_event_placeholder.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
                </AspectRatio>
                
                {}
                <Badge className="absolute right-4 top-4 translate-y-2 opacity-0 shadow-lg transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100 bg-primary text-primary-foreground font-default font-black text-sm tracking-widest pointer-events-none px-4 py-1.5">
                  {formatEventDate(post.date)}
                </Badge>
              </div>
              
              <CardHeader className="p-6">
                <CardTitle className="font-default text-xl font-bold leading-tight tracking-tight transition-colors group-hover:text-primary line-clamp-2 uppercase">
                  {post.title}
                </CardTitle>
              </CardHeader>
            </Card>
          </Link>
        </div>)}
    </div>;
}
export default function ThePulse() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}